import { render, staticRenderFns } from "./TeleconsultoSurveySelection.vue?vue&type=template&id=a92e6752&"
import script from "./TeleconsultoSurveySelection.vue?vue&type=script&lang=js&"
export * from "./TeleconsultoSurveySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports